<template>
    <div class="wrap clearfix">

        <div class="clearfix">
            <div class="right">
                <ul class="tab">
                    <li :class="{select: tab_no === 1}" @click="tab_no = 1">상담정보</li>
                    <li :class="{select: tab_no === 2}" @click="select_tab(2,note_id)">수납/약국</li>
                </ul>
                <div class="box">
                    <consult-tel-content v-show="tab_no === 1" :note_id="note_id" :note_status="note_status" ref="consultTelContent"></consult-tel-content> 
                    <consult-tel-payment v-show="tab_no === 2" :note_id="note_id" :note_status="note_status" :note="note"></consult-tel-payment>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ConsultTelContent from '@/components/ConsultTel/ConsultTelContent.vue'
    import ConsultTelPayment from '@/components/ConsultTel/ConsultTelPayment.vue'

export default {
    name: 'consult-tel-pop',
    props: ['note_id'],
    // params: ['note'],
    data() {
      return {
        note: {},
        notes : [],
        chosen_note: {},
        is_paging : true,
        tab_no: 1,
        note_status: 0,
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
        select_tab(tab_id, note_id) {
            if(tab_id==2) this.note_id = note_id;   //수납 최신 상태 유지를 위해
            this.tab_no = tab_id;
        },

    },
    mounted() {
        // console.log('params', JSON.parse(JSON.stringify(this.$route.params)));
        
        this.note = JSON.parse(JSON.stringify(this.$route.params));
        // console.log('note', this.note.note_id)
     },
    components: {
      ConsultTelContent, ConsultTelPayment
    }
  }

</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    .element { overscroll-behavior: contain; }

    /* Main */
    .wrap {
        width: 100%;
        max-width: 800px;
        margin: 5px auto 5px;
    }

    .right {
        border: 1px solid #e7e7e9;
        box-sizing: border-box;
        background-color: #fff;
        width: 570px;
    }

    .right .tab {
        width: 100%;
        height: 50px;
        font-size: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e7e7e9;
    }

    .right .tab > li {
        color: #b8b8b8;
        width: 50%;
        height: 50px;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font: 500 15px/50px 'Noto Sans KR', sans-serif;
    }

    .right .tab > li:hover,
    .right .tab .select {
        color: #736ee6;
        position: relative;
    }

    .right .tab > li:hover::after,
    .right .tab .select::after {
        content: '';
        display: block;
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        background-color: #736ee6;
    }

    .right .box {
        width: 100%;
        height: 100%;
        padding: 30px 30px;
        position: relative;
        box-sizing: border-box;
    }
    
</style>
